var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28367 10.9573C7.21561 10.6898 5.0291 9.93534 3.04686 7.95312C1.06465 5.97091 0.310246 3.7844 0.0426465 2.71635C-0.111136 2.10256 0.16579 1.51026 0.635349 1.17486L1.86633 0.295582C2.58659 -0.218885 3.58857 -0.0443084 4.09239 0.683438L4.86736 1.80286C5.19633 2.27804 5.08287 2.92931 4.61257 3.26523L3.99463 3.70663C4.08816 4.06436 4.37903 4.79901 5.29002 5.70999C6.201 6.62097 6.93565 6.91182 7.29338 7.00535L7.73475 6.38738C8.0707 5.91714 8.72197 5.80363 9.19713 6.1326L10.3166 6.90759C11.0443 7.41146 11.2189 8.41337 10.7044 9.13364L9.82514 10.3647C9.48972 10.8342 8.89745 11.1111 8.28367 10.9573ZM3.79458 7.20541C5.5972 9.00802 7.58645 9.69255 8.54062 9.93163C8.6801 9.96653 8.84871 9.91234 8.96465 9.75002L9.84396 8.51901C10.0154 8.27897 9.95727 7.94498 9.71464 7.77701L8.59524 7.00202L8.12156 7.66519C7.928 7.93621 7.57 8.14875 7.15316 8.05882C6.63291 7.94657 5.67117 7.58657 4.54231 6.4577C3.41344 5.32884 3.05344 4.36711 2.94118 3.84685C2.85124 3.43001 3.06381 3.07202 3.33482 2.87844L3.99796 2.40476L3.22297 1.28534C3.05503 1.04275 2.72104 0.984563 2.48096 1.15605L1.24997 2.03533C1.08763 2.15128 1.03344 2.31989 1.06838 2.45935C1.30745 3.41356 1.99198 5.40281 3.79458 7.20541Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallsupport);
export default __webpack_public_path__ + "static/media/callsupport.83b925c51cc1341dea68a7114407e4ce.svg";
export { ForwardRef as ReactComponent };